<template>
  <div class="container" :class="isMenuCollapse? 'hidemenu' : ''">
    <!-- 左边 -->
    <div class="left-container">

      <div class="menu-box">
        <!-- 切换菜单按钮 -->
        <hamburger :is-active="isMenuCollapse" class="hamburger-container" @toggleClick="toggleSideBar" />
      </div>
      <div class="menu-list">

        <el-card style="width:200px;float: left;height:100%;cursor: pointer;" v-show="!isMenuCollapse">
          <el-table ref="table1" :data="menuOptions1" @row-click="rowclick1" highlight-current-row>
            <el-table-column property="projectDesc" show-overflow-tooltip>
              <template slot="header" slot-scope="scope">
                <el-input v-model="search1" size="mini" placeholder="输入关键字搜索" />
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <el-card style="width:200px;float: left;height:100%;cursor: pointer;">
          <el-table ref="table2" :data="menuOptions2" @row-click="rowclick2" highlight-current-row v-loading="zijiloading">
            <el-table-column property="flowId">
              <template slot="header" slot-scope="scope">
                <el-input v-model="search2" size="mini" placeholder="输入关键字搜索" />
              </template>
            </el-table-column>

          </el-table>
        </el-card>

      </div>
    </div>

    <!-- 右边 -->
    <div class="main">
      <!-- 内容区域 -->
      <content-table ref="content" @openCode="handleSelectCode"></content-table>
    </div>

  </div>
</template>

<script>

import Hamburger from '@/components/Hamburger'
import ContentTable from './components/contentTableDispatch.vue'
import clipboard from '@/directive/clipboard/index.js'
import { azkabanProjectList, azkabanFlowProjectId } from '@Sys~/api/sys'

// 弹窗默认的数据内容

export default {
  components: { Hamburger, ContentTable },
  data() {
    return {
      isMenuCollapse: false, // 导航栏是否打开
      // 菜单列表
      menuData1: [],
      originalMenuData1: [],
      menuData2: [],
      originalMenuData2: [],
      zijiloading: false,
      search1: '', // 搜索
      search2: '', // 搜索
      projectId: "",
      flowId: "",

      eventDesc: '',
    }
  },
  //   directives: {
  //     clipboard
  //   },
  computed: {
    // 模糊搜索 菜单
    menuOptions1() {
      const search = this.search1.replace(/^\s+|\s+$/g, "")
      this.menuData1 = JSON.parse(JSON.stringify(this.originalMenuData1))
      if (search) {
        return this.menuData1.filter(menu => {
          return String(menu['projectDesc']).toLowerCase().indexOf(search) >= 0
        })
      }
      return this.menuData1
    },

    menuOptions2() {
      const search = this.search2.replace(/^\s+|\s+$/g, "")
      this.menuData = JSON.parse(JSON.stringify(this.originalMenuData2))
      if (search) {
        return this.menuData2.filter(menu => {
          return String(menu['flowId']).toLowerCase().indexOf(search) >= 0
        })
      }
      return this.menuData2
    }
  },


  created() {
    this.getMenu1() // 获取菜单列表
  },

  methods: {
    // 获取菜单列表
    getMenu1() {
      azkabanProjectList().then(response => {
        if (response.code == 1) {
          this.menuData1 = JSON.parse(JSON.stringify(response.data))
          this.originalMenuData1 = JSON.parse(JSON.stringify(response.data))
          if (this.menuData1.length > 0) {
            this.projectId = this.menuData1[0].projectId
            this.$nextTick(() => {
              this.$refs.table1.setCurrentRow(this.$refs.table1.data[0]);
            })

            this.getMenu2();
          }
        }
      })
    },
    getMenu2() {
      this.zijiloading = true;
      azkabanFlowProjectId(this.projectId).then(response => {
        if (response.code == 1) {
          this.menuData2 = JSON.parse(JSON.stringify(response.data))
          this.originalMenuData2 = JSON.parse(JSON.stringify(response.data))

          if (this.menuData2.length > 0) {
            this.flowId = this.menuData2[0].flowId
            this.$nextTick(() => {
              this.$refs.table2.setCurrentRow(this.$refs.table2.data[0]);
            })
            this.$refs['content'].getList(this.flowId) // 初始化详情
          }


        }
        this.zijiloading = false;
      })
    },

    rowclick1(e, v, b, j) {
      this.projectId = e.projectId
      this.getMenu2();
    },
    rowclick2(e, v, b, j) {
      this.$refs['content'].getList(e.flowId) // 初始化详情
    },




    // 切换导航
    toggleSideBar() {
      this.isMenuCollapse = !this.isMenuCollapse
    },

    // 切换菜单
    handleSelect(key, keyPath) {
      // console.log(key, keyPath);
      this.activeName = key
      this.$refs['content'].getList(key) // 初始化详情
    },

    // 切换菜单 并 定位到头部
    handleSelectCode(key) {
      this.activeName = key
      this.$refs['content'].getList(key) // 初始化详情

      //   const menu = this.$refs['scroll'].wrap
      //   let currentIndex = 0
      //   this.menuOptions.forEach((item, index) => {
      //     if (item.eventCode == key) {
      //       currentIndex = index
      //     }
      //   })
      //   // console.log(currentIndex)
      //   // console.log(this.$refs['scroll'])
      //   menu.scrollTop = currentIndex * 30
    }
  }
}
</script>

<style lang="scss" scoped>
.container {
  min-height: 100%;
  position: relative;
  transition: 0s width ease-in-out, 0s padding-left ease-in-out,
    0s padding-right ease-in-out;
}
// 左边
.left-container {
  background: #fff;
  transition: width 0.28s;
  width: 401px;
  height: 100%;
  position: fixed;
  font-size: 0px;
  top: 100px;
  bottom: 0;
  left: 225px;
  z-index: 9;
  border-right: 1px solid #e6e6e6;

  // reset element-ui css
  .horizontal-collapse-transition {
    transition: 0s width ease-in-out, 0s padding-left ease-in-out,
      0s padding-right ease-in-out;
  }
  .scrollbar-wrapper {
    overflow-x: hidden !important;
    width: 100%;
  }

  ::v-deep .el-scrollbar__wrap {
    overflow-x: hidden !important;
  }

  .el-scrollbar__bar.is-vertical {
    right: 0px;
  }

  .el-scrollbar {
    height: 100%;
  }

  .el-menu {
    border: none;
    height: 100%;
  }

  .menu-list {
    width: 100%;
    height: calc(100vh - 118px);
    overflow: hidden;

    ::v-deep .el-card__body {
      padding: 0px 5px;
    }

    ::v-deep .el-table .el-table__body td {
      font-size: 13px;
      padding: 5px 0;
    }
  }

  .menu-box {
    width: 100%;
    text-align: center;
    position: relative;

    .hamburger-container {
      position: absolute;
      top: -19px;
      right: -30px;
      cursor: pointer;
    }
    .title-box {
      width: 100%;
      height: 0px;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      margin-top: 10px;
      padding: 0 20px;
      background: #dfe6ec;
      transition: width 0.28s;
      span {
        font-size: 14px;
        opacity: 1;
        transition: 0s width ease-in-out, 0s padding-left ease-in-out,
          0s padding-right ease-in-out;
      }
    }
  }

  .icon {
    font-size: 18px;
    font-weight: bolder;
    cursor: pointer;
    color: #409eff;
  }
}

// 右边
.main {
  min-height: 100%;
  height: auto;
  transition: all 0.28s;
  margin-left: 400px;
  position: relative;
  z-index: 1;
  padding: 10px 20px;
}

// 折叠侧边栏后
.hidemenu {
  .left-container {
    width: 200px !important;
    top: 100px;
    transition: 0s width ease-in-out, 0s padding-left ease-in-out,
      0s padding-right ease-in-out;
    .menu-list {
      height: calc(100vh - 118px);
    }
    .title-box {
      justify-content: center;
      span {
        transition: opacity 5s;
        opacity: 0;
      }
    }
  }

  .el-menu--collapse {
    width: 39px !important;
  }

  .main {
    margin-left: 200px;
  }
}

// 侧边栏折叠
.hideSidebar {
  .left-container {
    transition: 0s width ease-in-out, 0s padding-left ease-in-out,
      0s padding-right ease-in-out;
    left: 69px !important;
  }
}

// 弹窗
.dialog {
  ::v-deep .el-dialog__body {
    padding: 10px 20px 20px;
    height: auto;
    max-height: calc(100vh - 25vh);
    overflow: auto;
  }

  .complete-box {
    margin-top: 20px;
    padding: 10px 0 20px;
    display: flex;
    flex-flow: column nowrap;
    justify-content: center;
    align-items: center;
    .check {
      font-size: 60px;
      color: #67c23a;
      margin: 10px 0;
    }
    .tips {
    }

    .copy-box {
      margin: 20px 0;
      padding: 10px;
      background: #dbdfe7;
      .list {
        display: flex;
        flex-flow: row nowrap;
        justify-content: flex-start;
        align-items: center;
        line-height: 2;
        .title {
          color: #7d7d7d;
        }
        .content {
          margin: 0 20px 0 10px;
        }

        .butn {
          padding: 3px 8px;
        }
      }
    }
  }
}

.box-card {
  ::v-deep .el-select__tags {
    .el-tag {
      max-width: 84%;
      overflow: hidden;
      display: flex;
      flex-flow: row nowrap;
      justify-content: space-between;
      align-items: center;
      .el-select__tags-text {
        width: 100%;
        overflow: hidden;
      }
    }
    .el-select__input {
      margin-left: 2px;
    }
  }
}
</style>